class UnbounceAnalytics {
    trackingUrl =
        ('https:' == document.location.protocol ? 'https://' : 'http://') +
        't.unbounce.com/trk' +
        '?';
    visitorId: string | null = null;
    pageId: string | null = null;

    setAccount(account: string) {
        this.appendParam('a', account);
    }

    trackGoal(goal: string) {
        this.track('g', goal);
    }

    track(action: string, value: string) {
        this.addVisitorId();
        this.addExcludedPageId();
        if (this.visitorId != null) {
            this.appendParam(action, value);
            const script = document.createElement('script');
            script.src = this.trackingUrl;
            script.type = 'text/javascript';
            script.async = true;
            document.body.appendChild(script);
        }
    }

    addExcludedPageId() {
        const pageCookie = this.getCookieValue('ubpv');
        if (pageCookie != null && this.pageId == null) {
            const cookieValues = unescape(pageCookie).split(',');
            if (cookieValues.length > 1) {
                this.pageId = cookieValues[1];
                this.appendParam('xp', this.pageId);
            }
        }
    }

    addVisitorId() {
        this.visitorId = this.getCookieValue('ubvt');
        if (this.visitorId != null) {
            this.appendParam('v', this.visitorId);
        }
    }

    appendParam(name: string, value: string) {
        if (this.haveSomeParamsAlready()) {
            this.trackingUrl = this.trackingUrl + '&';
        }
        this.trackingUrl = this.trackingUrl + name + '=' + value;
    }

    getCookieValue(cookieName: string) {
        const cookies = document.cookie;

        let cookieValue = null;
        let pos = cookies.indexOf(cookieName + '=');

        if (pos > -1) {
            const start = pos + cookieName.length + 1;
            let end = cookies.indexOf(';', start);
            end = end > -1 ? end : cookies.length;

            cookieValue = cookies.substring(start, end);
        }
        return cookieValue;
    }

    haveSomeParamsAlready() {
        return this.trackingUrl.charAt(this.trackingUrl.length - 1) != '?';
    }
}

export default {
    track() {
        const ua = new UnbounceAnalytics();
        ua.trackGoal('convert');
    }
};
